import {
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconSizeEnum,
  Typography,
} from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { Clock } from '@/components/Clock';
import { HelpTour } from '@/components/HelpTour/HelpTour';
import { Shorcut } from '@/components/Shorcut/Shorcut';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';

import { useClipsTour } from '../../hooks/use-clips-tour';

export function ClipHeaderName() {
  const { t } = useTranslation();
  const { isHeaderVisible } = useBroadcastScheduleProgram();
  const { startTour } = useClipsTour();

  return (
    <div className="flex flex-wrap items-center">
      <Typography
        fontSize={FontSizeEnum.Xl}
        weight={FontWeightEnum.Bold}
        color={FontColorEnum.Dark10}
      >
        {t('Cortes')}
      </Typography>
      <div className="flex flex-1 items-center justify-end">
        {isHeaderVisible && (
          <div className="flex items-center gap-2">
            <Clock fontSize={FontSizeEnum.Md} iconSize={IconSizeEnum.SM} />
            <Shorcut />
            <HelpTour tour={startTour} />
          </div>
        )}
      </div>
    </div>
  );
}
